import { render, staticRenderFns } from "./courseProjectsMangeAudit.vue?vue&type=template&id=7319fd9a&scoped=true"
import script from "./courseProjectsMangeAudit.vue?vue&type=script&lang=js"
export * from "./courseProjectsMangeAudit.vue?vue&type=script&lang=js"
import style0 from "./courseProjectsMangeAudit.vue?vue&type=style&index=0&id=7319fd9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7319fd9a",
  null
  
)

export default component.exports